import { useState, useCallback, useEffect, } from "react"
import { Link, useParams, useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from "framer-motion"
import {
  BookOpen, Target, Users, GraduationCap, Save, X, Plus, Trash2, FileText, ExternalLink, ClipboardList, Loader, Pencil,
  ToggleLeft, ToggleRight, FileDown, Gamepad2, LayoutGrid, Search, Clock, CheckCircle, Book, ListFilter, ListOrdered,
  ChevronDown, ChevronUp, Mountain, MessageCircleQuestion, MessageCircleMore, Edit
} from 'lucide-react';
import Select from 'react-select'
import { getLessons as apiGetLessons, getLessonsAttachs, getTestsByContent, toggleExamStatus, fetchExamBank, updateQuestion, deleteQuestion, addLesson, updateLesson, fetchAttachmentFile, getContentDetail, createContentDetail, updateContentDetail, saveQuestions } from '@/api/kuizy'
import ConfirmModal from "@/widgets/ConfirmModal"
import Drawer from '@/layout/Drawer'
import { listKnowledge, getSubjectName as getContent, } from '@/api/kuizy'
import { formatDateTime, typeExam_Order, typeOption_Order, levelMapping, examTypeMapping, typeSummaryMapping, optionLabel } from '@/settings/master'
import PlayerRunModal from '@/widgets/PlayerRunModal'
import TestExportModal from '@/widgets/TestExportModal'
import ManualQuestionForm from '@/widgets/ManualQuestionForm'

/* options */
const optAll = { value: '', label: 'ทั้งหมด' }
const toOptsWithAll = obj => [optAll, ...Object.entries(obj).map(([k, v]) => ({ value: k, label: v }))]
const toOptsNoAll = obj => Object.entries(obj).map(([k, v]) => ({ value: k, label: v }))

const tabs = [
  { id: "detail", label: "รายละเอียดเนื้อหา" },
  { id: "content", label: "เนื้อหา" },
  { id: "exambank", label: "คลังข้อสอบ" },
  { id: "examtest", label: "จัดการชุดข้อสอบ" },
]

const StatusBadge = ({ active }) => (
  <span
    className={[
      'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium whitespace-nowrap',
      active ? 'bg-green-100 text-green-700' : 'bg-rose-100 text-rose-700'
    ].join(' ')}
  >
    {active ? <CheckCircle size={12} /> : <ToggleLeft size={12} />}
    {active ? 'เปิด' : 'ปิด'}
  </span>
)

const MetaChip = ({ icon: Icon, label }) => (
  <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 rounded-full px-2.5 py-1 text-[11px]">
    <Icon size={12} /> {label}
  </span>
)

export default function LessonDetailPage() {
  const { cid } = useParams()
  const [activeTab, setActiveTab] = useState("detail")
  const [isEditing, setIsEditing] = useState(false)
  const [dataLessons, setDataLessons] = useState([])
  const [items, setItems] = useState([])
  const [alert, setAlert] = useState({ open: false, msg: '' })
  const [loading, setLoad] = useState(false)
  const [contentData, setContentData] = useState(null)
  const [runModal, setRunModal] = useState({ open: false, test: null })
  const [detailOpen, setDetail] = useState(false)
  const [exportOpen, setExport] = useState(false)
  const [selTestId, setSelTest] = useState(null)
  const [selcId, setSelCid] = useState(null)
  const [showExpired, setShowExpired] = useState(false)
  const [searchInput, setSI] = useState('')
  const [searchTest, setST] = useState('')
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [searchTxt, setSTxt] = useState('')
  const navigate = useNavigate()

  // Bank Filter State
  const [lvF, setLv] = useState(optAll)
  const [exF, setEx] = useState(optAll)
  const [sumF, setSum] = useState(optAll)
  const [lessonF, setLessonF] = useState(optAll)
  const [searchIn, setSearchIn] = useState('')

  // Edit / Delete State
  const [open, setOpen] = useState(false)
  const [editItem, setEdit] = useState(null)
  const [saving, setSav] = useState(false)
  const [delQ, setDelQ] = useState(null)
  const [delLoad, setDL] = useState(false)
  const [expanded, setExpanded] = useState(new Set())

  // Lesson Drawer State
  const [lessonDrawerOpen, setLessonDrawerOpen] = useState(false)
  const [lessonItem, setLessonItem] = useState(null)
  const [lessonIsNew, setLessonIsNew] = useState(false)
  const [lessonSaving, setLessonSaving] = useState(false)

  // Manual Add Question State
  const [showManualPopup, setShowManualPopup] = useState(false)
  const [manualOptions, setManualOptions] = useState(Array(4).fill(0).map(() => ({ desc: '', points: 1 })))
  const [manualCorrect, setManualCorrect] = useState([])
  const [newQuestionText, setNewQuestionText] = useState('')
  const [manualLessonId, setManualLessonId] = useState('')
  const [manualTypeSummary, setManualTypeSummary] = useState('TF')
  const [manualLevel, setManualLevel] = useState('2')

  const handleEdit = () => {
    setActiveTab("detail")
    setIsEditing(true)
  }

  const startNewLesson = () => {
    setLessonItem({
      lesson_name: '',
      content_id: cid,
      difficult_level: '2',
      exam_type: 'multipleChoice',
      type_summary: 'TF',
      type_summary_min: 1,
      type_summary_max: 4
    })
    setLessonIsNew(true)
    setLessonDrawerOpen(true)
  }

  const saveLesson = async () => {
    if (!lessonItem?.lesson_name?.trim()) {
      setAlert({ open: true, msg: 'กรอกชื่อบทเรียน' })
      return
    }
    setLessonSaving(true)
    try {
      if (lessonIsNew) {
        await addLesson({ ...lessonItem, lesson_name: lessonItem.lesson_name.trim() })
      } else {
        await updateLesson({
          id: lessonItem.lesson_id,
          lesson_name: lessonItem.lesson_name.trim(),
          content_id: lessonItem.content_id,
          difficult_level: lessonItem.difficult_level,
          type_summary: lessonItem.type_summary,
          type_summary_min: lessonItem.type_summary_min,
          type_summary_max: lessonItem.type_summary_max,
          exam_type: lessonItem.exam_type
        })
      }
      await fetchData()
      setLessonDrawerOpen(false)
    } catch {
      setAlert({ open: true, msg: 'บันทึกไม่สำเร็จ' })
    } finally {
      setLessonSaving(false)
    }
  }

  const openPlayerRunConfig = t => {
    if (!t?.test_id) return
    setRunModal({ open: true, test: t })
  }

  const loadInitial = async () => {
    if (!cid) return
    const { data } = await listKnowledge(cid)
    const ready = (data.files || []).map(d => ({ ...d, stage: 'done', progress: 100 }))
    setItems(ready)
  }

  useEffect(() => {
    if (!cid) return
    getContent(cid)
      .then(r => setContentData(r.data))
      .catch(() => setContentData(null))
  }, [cid])

  useEffect(() => {
    loadInitial()
  }, [cid])

  const fetchData = useCallback(async () => {
    setLoad(true)
    try {
      const { data } = await getLessonsAttachs({ contentId: cid })

      const lessons = Array.isArray(data?.data) ? data.data : []

      const withSubLessons = lessons.map(l => ({
        ...l,
        sub_lessons: (l.attachments || []).map(a => ({
          id: a.id,
          title: a.name,
          type: a.type,
          url: a.download_url || a.url
        }))
      }))

      setDataLessons(withSubLessons)

    } catch {
      setAlert({ open: true, msg: 'โหลดบทเรียนไม่สำเร็จ' })
    } finally {
      setLoad(false)
    }
  }, [cid])

  const formatDuration = (mins) => {
    if (!mins) return "-";
    return `${mins} นาที`;
  };

  useEffect(() => { fetchData() }, [fetchData])
  const [tests, setTests] = useState([]);

  const loadTests = useCallback(async () => {
    setLoad(true)
    try {
      const { data } = await getTestsByContent(cid, {
        status: showExpired ? 'inactive' : 'active',
        name: searchTest || undefined,
      })
      setTests(data)
    } catch {
      setAlert({ open: true, msg: 'โหลดบทเรียนไม่สำเร็จ' })
    } finally {
      setLoad(false)
    }
  }, [cid, showExpired, searchTest])

  const fetchDataExamBank = useCallback(async () => {
    // if (tab !== 'bank') return
    setLoad(true)
    try {
      const { data } = await fetchExamBank({
        content_id: cid,
        lesson_id: lessonF.value || undefined,
        level: lvF.value || undefined,
        type_summary: sumF.value || undefined,
        exam_type: exF.value || undefined,
        search: searchTxt || undefined,
        page: 1,
        pageSize: 'all'
      })
      const list = Array.isArray(data?.data) ? data.data : []
      setRows(list)
      setTotal(parseInt(data?.total || 0, 10))

      // ใช้ข้อมูลบทเรียนจากแถวแรก (ถ้ามี) เติม meta เริ่มต้น
      // if (list.length) {
      //   const f = list[0]
      //   setMeta(m => ({
      //     ...m,
      //     difficult_level: (f.difficult_level ?? f.level ?? m.difficult_level)?.toString(), // <<--
      //     exam_type: f.exam_type || m.exam_type,
      //     type_summary: f.type_summary || m.type_summary,
      //     option_style: f.option_style || m.option_style
      //   }))
      // }
    } catch {
      setRows([])
      setTotal(0)
    } finally {
      setLoad(false)
    }
  }, [cid, searchTxt, lvF, exF, sumF, lessonF])

  useEffect(() => {
    if (cid) {
      loadTests();
      fetchDataExamBank();
    }
  }, [cid, loadTests, fetchDataExamBank]);


  const toggleActive = async t => {
    await toggleExamStatus(t.test_id, !t.active)
    setTests(r => r.map(x => x.test_id === t.test_id ? { ...x, active: !x.active } : x))
  }

  const openExport = t => {
    setSelTest(t.test_id)
    setSelCid(t.content_id)
    setExport(true)
  }

  const openDetail = t => {
    if (!t.test_id) return
    setSelTest(t.test_id)
    setSelCid(t.content_id)
    setDetail(true)
  }

  // --- Bank Handlers ---
  const toggleAns = id => {
    const s = new Set(expanded)
    s.has(id) ? s.delete(id) : s.add(id)
    setExpanded(s)
  }

  const startEdit = q => { setEdit(JSON.parse(JSON.stringify(q))); setOpen(true) }

  const updOption = (idx, field, val) => {
    const key = Object.keys(editItem.answer[idx])[0]
    const entry = editItem.answer[idx][key]
    const isObj = typeof entry === 'object'
    const newEntry =
      field === 'desc'
        ? (isObj ? { ...(entry || {}), description: val } : val)
        : { ...(isObj ? entry : { description: entry || '' }), points: val }
    const newAns = editItem.answer.map((a, i) => i === idx ? { [key]: newEntry } : a)
    setEdit(p => ({ ...p, answer: newAns }))
  }

  const toggleCorrect = key => {
    const isSingle = editItem.type_summary === 'TF'
    let corr = Array.isArray(editItem.correct) ? [...editItem.correct] : []
    if (corr.includes(key)) {
      corr = corr.filter(k => k !== key)
    } else {
      corr = isSingle ? [key] : [...corr, key]
    }
    if (corr.length === 0 && editItem.type_summary !== 'PO') return
    setEdit(p => ({ ...p, correct: corr }))
  }

  const saveEdit = async () => {
    if (!editItem) return
    setSav(true)
    try {
      await updateQuestion({
        id: editItem.id,
        question: editItem.question,
        answer: editItem.answer,
        correct: editItem.correct,
        option_style: editItem.option_style,
        content_id: cid,
        lesson_id: editItem.lesson_id, // Ensure lesson_id is passed if available
        lesson_name: editItem.lesson_name || ''
      })
      await fetchDataExamBank()
      setOpen(false)
    } catch {
      setAlert({ open: true, msg: 'บันทึกไม่สำเร็จ' })
    } finally {
      setSav(false)
    }
  }

  const confirmDel = async () => {
    if (!delQ) return
    setDL(true)
    try {
      await deleteQuestion(delQ.id)
      await fetchDataExamBank()
    } finally {
      setDL(false)
      setDelQ(null)
    }
  }

  const addManualQuestion = async () => {
    if (!newQuestionText.trim()) { setAlert({ open: true, msg: 'กรุณาป้อนข้อความคำถาม' }); return; }
    if (manualOptions.some(o => !o.desc.trim())) { setAlert({ open: true, msg: 'กรุณาป้อนตัวเลือกให้ครบ' }); return; }
    if (manualCorrect.length === 0 && manualTypeSummary !== 'PO') { setAlert({ open: true, msg: 'เลือกคำตอบถูกต้องอย่างน้อย 1 ค่า' }); return; }
    if (!manualLessonId) { setAlert({ open: true, msg: 'กรุณาเลือกบทเรียน' }); return; }

    const selectedLesson = dataLessons.find(l => l.lesson_id === manualLessonId);

    const answerObjArr = manualOptions.map((o, idx) => ({
      [`option${idx + 1}`]: manualTypeSummary === 'PO'
        ? { description: o.desc, points: o.points }
        : o.desc
    }))

    const newQ = {
      lesson_id: manualLessonId,
      lesson_name: selectedLesson ? selectedLesson.lesson_name : '',
      content_id: cid,
      question: newQuestionText,
      answer: answerObjArr,
      correct: [...manualCorrect],
      difficult_level: manualLevel,
      type_summary: manualTypeSummary,
      exam_type: 'multipleChoice',
      created_by: localStorage.getItem('userId') || '1'
    }

    setLoad(true)
    try {
      await saveQuestions({ questions: [newQ] })
      await fetchDataExamBank()
      setShowManualPopup(false)
      setNewQuestionText('')
      setManualOptions(Array(4).fill(0).map(() => ({ desc: '', points: 1 })))
      setManualCorrect([])
      setAlert({ open: true, msg: 'เพิ่มข้อสอบสำเร็จ', type: 'success' })
    } catch (e) {
      setAlert({ open: true, msg: e.message || 'เพิ่มข้อสอบไม่สำเร็จ' })
    } finally {
      setLoad(false)
    }
  }


  const Toolbar = (
    <motion.div
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: .35, delay: .05 }}
      className="flex flex-col md:flex-row md:items-end gap-4 bg-white rounded-xl shadow-md p-4"
    >
      <div className="w-full md:w-[240px]">
        <label className="flex items-center gap-1 text-sm mb-2">
          <ListFilter size={16} /> สถานะ
        </label>
        <div className="inline-flex rounded-lg overflow-hidden border border-gray-200">
          <button
            onClick={() => setShowExpired(false)}
            className={[
              'px-4 py-2 text-sm whitespace-nowrap min-w-[72px]',
              !showExpired ? 'bg-green-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
            ].join(' ')}
          >
            เปิด
          </button>
          <button
            onClick={() => setShowExpired(true)}
            className={[
              'px-4 py-2 text-sm whitespace-nowrap min-w-[72px]',
              showExpired ? 'bg-rose-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
            ].join(' ')}
          >
            ปิด
          </button>
        </div>
      </div>

      {/* ค้นหา */}
      <div className="flex flex-col gap-1 flex-1">
        <label className="flex items-center gap-1 text-sm">
          <Search size={16} /> ค้นหาชุดสอบ
        </label>
        <div className="relative">
          <input
            value={searchInput}
            onChange={e => setSI(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && setST(searchInput)}
            className="w-full border border-gray-300 rounded-lg px-10 py-2 text-sm focus:ring-2 focus:ring-primary"
            placeholder="พิมพ์ชื่อชุดสอบแล้วกด Enter"
          />
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => setST(searchInput)}
          className="inline-flex items-center gap-1 bg-secondary hover:bg-primary text-white rounded-lg px-3 py-2 text-sm"
        >
          <Search size={16} /> ค้นหา
        </button>
      </div>
    </motion.div>
  )

  return (
    <div className="min-h-screen pb-20">
      {/* ================= HERO ================= */}
      <section className="relative lg:rounded-3xl lg:overflow-hidden mx-4 sm:mx-6 mt-6">
        {/* BG IMAGE */}
        <div
          className="hidden lg:block absolute inset-0 bg-center bg-cover scale-110 blur-md"
          style={{
            backgroundImage: `url(${contentData?.image})`,
          }}
        />

        {/* DARK OVERLAY */}
        <div className="hidden lg:block absolute inset-0 bg-black/50" />

        {/* CONTENT */}
        <div
          className="
            relative z-10
            lg:p-12
            flex flex-col lg:flex-row
            gap-6 lg:gap-10
            items-start lg:items-center
            justify-between
            text-white
          "
        >
          {/* LEFT */}
          <div className="hidden lg:block max-w-xl">
            <p className="text-pink-400 text-2xl sm:text-3xl lg:text-4xl font-semibold mb-2">
              {contentData?.name}
            </p>
            <p className="text-gray-300 text-sm sm:text-base">
              {contentData?.code}
            </p>
          </div>

          {/* RIGHT CARD */}
          <motion.div
            layout
            className="
              bg-white rounded-2xl shadow-xl
              w-full sm:max-w-md lg:w-96
              p-4 sm:p-5
              text-black
              mx-auto lg:mx-0
            "
          >
            <div className="h-40 sm:h-44 bg-pink-500 rounded-xl mb-4 overflow-hidden">
              <img
                src={contentData?.image}
                alt="content-banner"
                className="w-full h-full object-fit"
              />
            </div>

            <button
              onClick={handleEdit}
              className="
                w-full bg-pink-500 hover:bg-pink-600
                text-white py-2 rounded-lg mb-4
                transition
              "
            >
              ✏️ แก้ไขข้อมูล
            </button>

            <div className="text-sm text-gray-600 space-y-2">
              <div>📘 15 บท</div>
              <div>📝 1 ชุดข้อสอบ</div>
            </div>
          </motion.div>
        </div>
      </section>



      {/* ================= TABS ================= */}
      <div className="mx-6 mt-10">

        <div className="flex gap-8 border-b relative">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id)
                setIsEditing(false)
              }}
              className="relative pb-4 font-medium text-gray-600"
            >
              {activeTab === tab.id && (
                <motion.div
                  layoutId="tab-indicator"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-pink-500"
                />
              )}
              <span
                className={
                  activeTab === tab.id
                    ? "text-pink-500"
                    : "hover:text-gray-900"
                }
              >
                {tab.label}
              </span>
            </button>
          ))}
        </div>

        {/* ================= TAB CONTENT (ANIMATED) ================= */}
        <div className="py-4 relative overflow-hidden">

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ x: 40, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -40, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              {activeTab === "detail" && (
                <DetailTab isEditing={isEditing} setIsEditing={setIsEditing} contentId={cid} />
              )}

              {activeTab === "content" && (
                <div className="text-gray-700">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="font-semibold text-lg">เนื้อหาบทเรียน ({dataLessons.length})</h3>
                    <button
                      onClick={startNewLesson}
                      className="inline-flex items-center gap-1 bg-pink-500 hover:bg-pink-600 text-white rounded-lg px-3 py-1.5 text-sm transition"
                    >
                      <Plus size={16} /> เพิ่มบทเรียน
                    </button>
                  </div>
                  <div className="space-y-4">
                    {dataLessons.map((lesson, index) => (
                      <LessonTreeItem
                        key={lesson.lesson_id || index}
                        lesson={lesson}
                        setDataLessons={setDataLessons}
                      />
                    ))}
                  </div>
                </div>
              )}


              {activeTab === "exambank" && (
                <>
                  <div className="flex justify-between items-center mt-4 mb-4 flex-wrap gap-3">
                    <h3 className="font-semibold text-lg">
                      คลังข้อสอบ ({total})
                    </h3>
                    <div className="flex gap-2">
                      <Link
                        to={`/content/${encodeURIComponent(cid)}/create-exam`}
                        className="text-sm bg-pink-500 text-white px-4 py-1.5 rounded-lg hover:bg-pink-600 transition"
                      >
                        เพิ่มข้อสอบ
                      </Link>
                      <button
                        onClick={() => {
                          setManualLessonId(lessonF.value || (dataLessons[0]?.lesson_id || ''))
                          setShowManualPopup(true)
                        }}
                        className="flex items-center gap-1 text-sm bg-primary text-white px-4 py-1.5 rounded-lg hover:bg-secondary transition"
                      >
                        <Plus size={16} />
                        เพิ่มข้อสอบด้วยตนเอง
                      </button>
                    </div>
                  </div>

                  {/* Filters */}
                  <div className="flex flex-wrap items-end gap-4 bg-white rounded-xl shadow-md p-4 mb-6">
                    <div className="flex flex-col gap-1 w-52">
                      <label className="flex items-center gap-1 text-sm"><Book size={16} /> บทเรียน</label>
                      <Select
                        classNamePrefix="rs"
                        options={[optAll, ...dataLessons.map(l => ({ value: l.lesson_id, label: l.lesson_name }))]}
                        value={lessonF}
                        onChange={setLessonF}
                      />
                    </div>
                    <div className="flex flex-col gap-1 w-52">
                      <label className="flex items-center gap-1 text-sm"><Mountain size={16} /> ระดับความยาก</label>
                      <Select classNamePrefix="rs" options={toOptsWithAll(levelMapping)} value={lvF} onChange={setLv} />
                    </div>
                    <div className="flex flex-col gap-1 w-52">
                      <label className="flex items-center gap-1 text-sm"><MessageCircleQuestion size={16} /> ประเภทข้อสอบ</label>
                      <Select classNamePrefix="rs" options={toOptsWithAll(examTypeMapping)} value={exF} onChange={setEx} />
                    </div>
                    <div className="flex flex-col gap-1 w-52">
                      <label className="flex items-center gap-1 text-sm"><MessageCircleMore size={16} /> ประเภทคำตอบ</label>
                      <Select classNamePrefix="rs" options={toOptsWithAll(typeSummaryMapping)} value={sumF} onChange={setSum} />
                    </div>
                    <div className="flex flex-col gap-1 flex-1 min-w-[200px]">
                      <label className="flex items-center gap-1 text-sm"><Search size={16} /> ค้นหา</label>
                      <div className="relative">
                        <input
                          value={searchIn}
                          onChange={e => setSearchIn(e.target.value)}
                          onKeyDown={e => e.key === 'Enter' && setSTxt(searchIn)}
                          className="w-full border border-gray-300 rounded-lg px-10 py-2 text-sm focus:ring-2 focus:ring-primary"
                          placeholder="ค้นหาคำถาม / รหัสข้อสอบ"
                        />
                        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                      </div>
                    </div>
                    <button
                      onClick={() => setSTxt(searchIn)}
                      className="inline-flex items-center gap-1 bg-secondary hover:bg-primary text-white rounded-lg px-3 py-2 text-sm"
                    >
                      <Search size={16} /> ค้นหา
                    </button>
                  </div>

                  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: .35, delay: .1 }}
                    className="bg-white rounded-xl shadow-md overflow-x-auto">
                    <table className="min-w-[880px] w-full text-sm">
                      <thead className="bg-gray-100 text-gray-600 whitespace-nowrap">
                        <tr>
                          <th className="py-2 px-3 w-14 text-left">#</th>
                          <th className="py-2 px-3 text-left">บทเรียน</th>
                          <th className="py-2 px-3 text-left">คำถาม</th>
                          <th className="py-2 px-3 text-right">ระดับความยาก</th>
                          <th className="py-2 px-3 text-right">ประเภทข้อสอบ</th>
                          <th className="py-2 px-3 text-right">ประเภทคำตอบ</th>
                          <th className="py-2 px-3 text-right hidden lg:table-cell">สร้างเมื่อ</th>
                          <th className="py-2 px-3 text-right hidden lg:table-cell">แก้ไขล่าสุด</th>
                          <th className="py-2 px-3 w-24 text-right">จัดการ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr><td colSpan={8} className="py-6 text-center"><Loader className="animate-spin" /></td></tr>
                        ) : rows.length === 0 ? (
                          <tr><td colSpan={8} className="py-6 text-center text-gray-500">ไม่พบข้อสอบ</td></tr>
                        ) : rows.map((q, i) => {
                          const isEx = expanded.has(q.id)
                          return (
                            <tr key={q.id} className="odd:bg-white even:bg-gray-50 align-top">
                              <td className="py-2 px-3">{i + 1}</td>
                              <td className="py-2 px-3">{q.lesson_name}</td>
                              <td className="py-2 px-3">
                                <div className="flex items-start gap-2">
                                  <button onClick={() => toggleAns(q.id)} className="text-primary mt-[2px]">
                                    {isEx ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                                  </button>
                                  <span className="whitespace-pre-line break-words">{q.question}</span>
                                </div>
                                {isEx && (
                                  <ul className="mt-2 ml-6 list-disc text-xs space-y-1">
                                    {(q.answer || []).map((a, idx) => {
                                      const k = Object.keys(a)[0]
                                      const v = a[k]
                                      const desc = typeof v === 'object' ? v.description : v
                                      return (
                                        <li key={k} className={Array.isArray(q.correct) && q.correct.includes(k) ? 'text-green-700' : ''}>
                                          {optionLabel(idx, q.option_style || 'thai')}. {desc}
                                        </li>
                                      )
                                    })}
                                  </ul>
                                )}
                              </td>
                              <td className="py-2 px-3 text-right">{levelMapping[q.level] || levelMapping[q.difficult_level] || '-'}</td>
                              <td className="py-2 px-3 text-right">{examTypeMapping[q.exam_type] || '-'}</td>
                              <td className="py-2 px-3 text-right">{typeSummaryMapping[q.type_summary] || '-'}</td>
                              <td className="py-2 px-3 text-right hidden lg:table-cell">{formatDateTime(q.created_at)}</td>
                              <td className="py-2 px-3 text-right hidden lg:table-cell">{formatDateTime(q.updated_at || q.created_at)}</td>
                              <td className="py-2 px-3 text-right space-x-2 whitespace-nowrap">
                                <button onClick={() => startEdit(q)} className="text-primary hover:text-primary/80"><Edit size={16} /></button>
                                <button onClick={() => setDelQ(q)} className="text-red-600 hover:text-red-500"><Trash2 size={16} /></button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </motion.div>
                </>
              )}

              {activeTab === "examtest" && (
                <>
                  {Toolbar}
                  <div className="flex justify-between items-center mt-4 mb-4">
                    <h3 className="font-semibold text-lg">
                      จัดการชุดข้อสอบ
                    </h3>
                    <Link
                      to={`/content/${encodeURIComponent(cid)}/tests/new`}
                      className="text-sm bg-pink-500 text-white px-4 py-1.5 rounded-lg hover:bg-pink-600 transition"
                    >
                      + เพิ่มชุดข้อสอบ
                    </Link>
                  </div>
                  <div>
                    {loading ? (
                      // Loading Skeleton
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[1, 2, 3].map((n) => (
                          <div key={n} className="h-40 bg-gray-100 rounded-xl animate-pulse"></div>
                        ))}
                      </div>
                    ) : tests.length > 0 ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {tests
                          .filter(t => t.test_id != null)
                          .map(t => (
                            <div
                              key={t.test_id}
                              className="relative border border-gray-200 rounded-xl p-4 flex flex-col gap-3 hover:shadow-md transition bg-white"
                            >
                              <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                  <button
                                    onClick={() => openDetail(t)}
                                    className="text-left text-gray-900 font-semibold leading-snug hover:text-primary line-clamp-2"
                                    title="ดูรายละเอียดชุดสอบ"
                                  >
                                    {t.test_name}
                                  </button>
                                  {t.description ? (
                                    <p className="text-xs text-gray-500 mt-1 line-clamp-3">{t.description}</p>
                                  ) : null}
                                </div>
                                <StatusBadge active={!!t.active} />
                              </div>

                              <div className="flex flex-wrap gap-1.5">
                                <MetaChip icon={LayoutGrid} label={`${t.question_count ?? t.question_ids?.length ?? '-'} ข้อ`} />
                                <MetaChip icon={ListOrdered} label={`เรียงข้อสอบ: ${typeExam_Order[t.exam_order] || 'normal'}`} />
                                <MetaChip icon={ListOrdered} label={`เรียงตัวเลือก: ${typeOption_Order[t.option_order] || 'normal'}`} />
                                <MetaChip icon={CheckCircle} label={`ผ่าน: ${t.criteria ?? 80}%`} />
                                <MetaChip icon={Clock} label={`${t.duration ?? 0} นาที`} />
                              </div>

                              <div className="flex items-end justify-between">
                                <div className="text-[11px] text-gray-500">
                                  <p>เริ่ม: {t.start_time ? formatDateTime(t.start_time) : 'ไม่จำกัด'}</p>
                                  <p>สิ้นสุด: {t.end_time ? formatDateTime(t.end_time) : 'ไม่จำกัด'}</p>
                                </div>
                                <div className="flex items-center gap-3">
                                  <button onClick={() => openPlayerRunConfig(t)} className="text-secondary hover:opacity-80" title="ทดลอง/รัน">
                                    <Gamepad2 size={18} />
                                  </button>
                                  <button onClick={() => navigate(`/content/${t.content_id}/tests/${t.test_id}/edit`)} className="text-primary hover:opacity-80" title="แก้ไข">
                                    <Pencil size={18} />
                                  </button>
                                  <button onClick={() => toggleActive(t)} className={t.active ? 'text-green-600' : 'text-rose-600'} title="สลับสถานะ">
                                    {t.active ? <ToggleRight size={20} /> : <ToggleLeft size={20} />}
                                  </button>
                                  <button onClick={() => openExport(t)} className="text-secondary hover:opacity-80" title="ส่งออก/พิมพ์">
                                    <FileDown size={18} />
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    )
                      : tests.length === 0 ? (
                        showExpired ? (
                          // Empty State: ไม่มีข้อมูล (โหมดดูข้อสอบหมดอายุ)
                          <div className="text-center py-16 bg-gray-50 rounded-xl border border-dashed border-gray-200">
                            <div className="bg-white p-3 rounded-full shadow-sm w-12 h-12 flex items-center justify-center mx-auto mb-3">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                            </div>
                            <h3 className="text-gray-900 font-medium text-lg">ไม่มีข้อมูล</h3>
                            <p className="text-gray-500 max-w-sm mx-auto">
                              ไม่พบชุดข้อสอบตามเงื่อนไขที่เลือก
                            </p>
                          </div>
                        ) : (
                          // Empty State: ไม่มีข้อสอบ + ให้สร้างได้
                          <div className="text-center py-16 bg-gray-50 rounded-xl border border-dashed border-gray-200">
                            <div className="bg-white p-3 rounded-full shadow-sm w-12 h-12 flex items-center justify-center mx-auto mb-3">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                            </div>
                            <h3 className="text-gray-900 font-medium text-lg">ยังไม่มีชุดข้อสอบ</h3>
                            <p className="text-gray-500 mb-6 max-w-sm mx-auto">
                              เริ่มสร้างแบบทดสอบแรกของคุณเพื่อวัดผลผู้เรียนได้เลย
                            </p>
                            <Link
                              to={`/content/${encodeURIComponent(cid)}/create-exam`}
                              className="text-pink-500 hover:text-pink-600 font-medium hover:underline"
                            >
                              สร้างข้อสอบใหม่ +
                            </Link>
                          </div>
                        )
                      ) : null}
                  </div>
                </>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
      {runModal.open && (
        <PlayerRunModal
          open={runModal.open}
          mode="create"
          runId={null}
          testId={runModal.test?.test_id}
          testMeta={runModal.test}
          onClose={() => setRunModal({ open: false, test: null })}
          onSuccess={() => setRunModal({ open: false, test: null })}
        />
      )}
      {exportOpen && (
        <TestExportModal
          visible={exportOpen}
          cid={selcId}
          testId={selTestId}
          onClose={() => setExport(false)}
        />
      )}
      {detailOpen && (
        <ExamDetailModal
          visible={detailOpen}
          testId={selTestId}
          cid={selcId}
          onClose={() => setDetail(false)}
        />
      )}

      {/* ───────── Drawer: Add/Edit Lesson ───────── */}
      <Drawer open={lessonDrawerOpen} onClose={() => setLessonDrawerOpen(false)} title={`${lessonIsNew ? 'เพิ่ม' : 'แก้ไข'}บทเรียน`}>
        {lessonItem && (
          <form onSubmit={e => { e.preventDefault(); saveLesson() }} className="flex flex-col gap-3">
            <label className="flex items-center gap-1 text-sm"><BookOpen size={14} /> ชื่อบทเรียน <span className="text-red-500 font-bold">*</span></label>
            <input
              value={lessonItem.lesson_name}
              onChange={e => setLessonItem({ ...lessonItem, lesson_name: e.target.value })}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary"
              placeholder="ชื่อบทเรียน"
            />

            <label className="flex items-center gap-1 text-sm"><Mountain size={14} /> ระดับความยาก <span className="text-red-500 font-bold">*</span></label>
            <Select
              classNamePrefix="rs"
              isClearable={false}
              options={toOptsNoAll(levelMapping)}
              value={toOptsNoAll(levelMapping).find(o => o.value === lessonItem.difficult_level)}
              onChange={o => setLessonItem({ ...lessonItem, difficult_level: o.value })}
            />

            <label className="flex items-center gap-1 text-sm"><MessageCircleQuestion size={14} /> ประเภทข้อสอบ <span className="text-red-500 font-bold">*</span></label>
            <Select
              classNamePrefix="rs"
              isClearable={false}
              options={toOptsNoAll(examTypeMapping)}
              value={toOptsNoAll(examTypeMapping).find(o => o.value === lessonItem.exam_type)}
              onChange={o => setLessonItem({ ...lessonItem, exam_type: o.value })}
            />

            <label className="flex items-center gap-1 text-sm"><MessageCircleMore size={14} /> ประเภทคำตอบ <span className="text-red-500 font-bold">*</span></label>
            <Select
              classNamePrefix="rs"
              isClearable={false}
              options={toOptsNoAll(typeSummaryMapping)}
              value={toOptsNoAll(typeSummaryMapping).find(o => o.value === lessonItem.type_summary)}
              onChange={o => setLessonItem({ ...lessonItem, type_summary: o.value })}
            />

            <button
              disabled={lessonSaving}
              className="bg-pink-500 hover:bg-pink-600 text-white rounded-lg px-4 py-2 mt-2 disabled:opacity-50"
            >
              {lessonSaving ? <Loader className="animate-spin" size={16} /> : 'บันทึก'}
            </button>
          </form>
        )}
      </Drawer>

      {/* ───────── Drawer: Edit Question ───────── */}
      <Drawer open={open} onClose={() => setOpen(false)} title="แก้ไขข้อสอบ">
        {editItem && (
          <>
            <label className="text-sm font-medium flex gap-2 mb-2">
              <MessageCircleQuestion size={16} /> คำถาม
            </label>
            <textarea
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm h-24 w-full focus:ring-2 focus:ring-primary mb-6"
              value={editItem.question}
              onChange={e => setEdit({ ...editItem, question: e.target.value })}
            />

            <label className="text-sm font-medium mt-2 flex gap-2 mb-2">
              <MessageCircleMore size={16} /> ตัวเลือก
            </label>
            <ul className="space-y-2">
              {(editItem.answer || []).map((opt, idx) => {
                const key = Object.keys(opt)[0]
                const val = opt[key]
                const isPO = editItem.type_summary === 'PO'
                const isCorr = Array.isArray(editItem.correct) && editItem.correct.includes(key)
                const desc = typeof val === 'object' ? (val.description || '') : (val || '')
                const pts = typeof val === 'object' ? (Number(val.points || 0)) : 0
                return (
                  <li key={idx} className="flex gap-2 items-start">
                    <span className="mt-2 font-semibold">{optionLabel(idx, editItem.option_style || 'thai')}</span>
                    <textarea
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary"
                      value={desc}
                      onChange={e => updOption(idx, 'desc', e.target.value)}
                    />
                    {isPO && (
                      <input
                        type="number"
                        className="w-24 border border-gray-300 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-primary"
                        value={pts}
                        onChange={e => updOption(idx, 'pts', Number(e.target.value))}
                      />
                    )}
                    {!isPO && (
                      <input
                        type="checkbox"
                        checked={isCorr}
                        onChange={() => toggleCorrect(key)}
                        className="mt-3"
                      />
                    )}
                  </li>
                )
              })}
            </ul>

            <button
              disabled={saving}
              onClick={saveEdit}
              className="bg-primary hover:bg-secondary text-white rounded-lg px-4 py-2 mt-4 disabled:opacity-50"
            >
              {saving ? <Loader className="animate-spin" size={16} /> : 'บันทึก'}
            </button>
          </>
        )}
      </Drawer>

      <AnimatePresence>
        {delQ && (
          <ConfirmModal
            type="confirm"
            title="ยืนยันการลบ"
            message="ลบคำถามนี้ ?"
            onConfirm={confirmDel}
            onCancel={() => setDelQ(null)}
            confirmDisabled={delLoad}
          />
        )}
        {alert.open && <ConfirmModal type="alert" title="แจ้งเตือน" message={alert.msg} onClose={() => setAlert({ open: false, msg: "" })} />}
      </AnimatePresence>
      <AnimatePresence>
        {showManualPopup && (
          <motion.div
            key="manual"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999] p-4"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.95, opacity: 0, y: 10 }}
              transition={{ duration: 0.25 }}
              className="bg-white rounded-xl w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto"
            >
              <h3 className="text-lg font-semibold mb-4">เพิ่มข้อสอบด้วยตนเอง</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium">บทเรียน</label>
                  <Select
                    classNamePrefix="rs"
                    options={[{ value: '', label: '-- เลือกบทเรียน --' }, ...dataLessons.map(l => ({ value: l.lesson_id, label: l.lesson_name }))]}
                    value={
                      manualLessonId
                        ? { value: manualLessonId, label: dataLessons.find(l => l.lesson_id === manualLessonId)?.lesson_name || '' }
                        : { value: '', label: '-- เลือกบทเรียน --' }
                    }
                    onChange={o => setManualLessonId(o?.value || '')}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium">ประเภทคำตอบ</label>
                  <Select
                    classNamePrefix="rs"
                    isClearable={false}
                    options={toOptsNoAll(typeSummaryMapping)}
                    value={toOptsNoAll(typeSummaryMapping).find(o => o.value === manualTypeSummary)}
                    onChange={o => {
                      setManualTypeSummary(o.value)
                      setManualCorrect([])
                    }}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium">ระดับความยาก</label>
                  <Select
                    classNamePrefix="rs"
                    isClearable={false}
                    options={toOptsNoAll(levelMapping)}
                    value={toOptsNoAll(levelMapping).find(o => o.value === manualLevel)}
                    onChange={o => setManualLevel(o.value)}
                  />
                </div>
              </div>
              <ManualQuestionForm
                typeSummary={manualTypeSummary}
                manualOptions={manualOptions}
                setManualOptions={setManualOptions}
                manualCorrect={manualCorrect}
                setManualCorrect={setManualCorrect}
                optionCount={8}
                typeSummaryMin={1}
                typeSummaryMax={4}
                newQuestionText={newQuestionText}
                setNewQuestionText={setNewQuestionText}
                addManualQuestion={addManualQuestion}
                openAlert={(msg) => setAlert({ open: true, msg })}
                hideAddButton
                hideAiButton={true}
              />
              <div className="flex justify-end gap-3 mt-6">
                <button
                  className="bg-primary hover:bg-secondary text-white rounded-lg px-4 py-2 text-sm font-semibold"
                  onClick={addManualQuestion}
                >
                  บันทึก
                </button>
                <button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg px-4 py-2 text-sm font-semibold"
                  onClick={() => setShowManualPopup(false)}
                >
                  ยกเลิก
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  )
}


const EMPTY_FORM = {
  description: '',
  objectives: [''],
  targets: [''],
  completion_percent: 80,
  exam_pass_percent: 80,
}

function DetailTab({
  isEditing,
  setIsEditing,
  contentId,
}) {
  const [detail, setDetail] = useState(null)   // null = ยังไม่มีใน DB
  const [form, setForm] = useState(EMPTY_FORM)
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [saving, setSaving] = useState(false)
  const [saveErr, setSaveErr] = useState(null)

  // ── fetch ──────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!contentId) return
    setLoadingDetail(true)
    getContentDetail(contentId)
      .then(r => {
        const d = r.data.data
        if (d && d.id) {
          setDetail(d)
          setForm({
            description: d.description || '',
            objectives: Array.isArray(d.objectives) && d.objectives.length ? d.objectives : [''],
            targets: Array.isArray(d.targets) && d.targets.length ? d.targets : [''],
            completion_percent: d.completion_percent ?? 0,
            exam_pass_percent: d.exam_pass_percent ?? 0,
          })
        }
      })
      .catch(() => { })
      .finally(() => setLoadingDetail(false))
  }, [contentId])

  // ── form helpers ───────────────────────────────────────────────────────────
  const setField = (field, val) => setForm(f => ({ ...f, [field]: val }))

  const setListItem = (field, idx, val) =>
    setForm(f => { const arr = [...f[field]]; arr[idx] = val; return { ...f, [field]: arr } })

  const addListItem = field =>
    setForm(f => ({ ...f, [field]: [...f[field], ''] }))

  const removeListItem = (field, idx) =>
    setForm(f => ({ ...f, [field]: f[field].filter((_, i) => i !== idx) }))

  // ── save ───────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    setSaving(true)
    setSaveErr(null)
    try {
      const payload = {
        content_id: contentId,
        description: form.description,
        objectives: form.objectives.filter(s => s.trim()),
        targets: form.targets.filter(s => s.trim()),
        completion_percent: Number(form.completion_percent),
        exam_pass_percent: Number(form.exam_pass_percent),
      }
      let res
      if (detail && detail.id) {
        res = await updateContentDetail({ ...payload, id: detail.id })
      } else {
        res = await createContentDetail(payload)
      }
      // อัปเดต detail state หลังบันทึก
      const updated = res?.data
      if (updated && updated.id) setDetail(updated)
      setIsEditing(false)
    } catch {
      setSaveErr('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
    } finally {
      setSaving(false)
    }
  }

  // ── cancel ─────────────────────────────────────────────────────────────────
  const handleCancel = () => {
    // reset form กลับเป็นข้อมูลที่โหลดมา
    if (detail && detail.id) {
      setForm({
        description: detail.description || '',
        objectives: Array.isArray(detail.objectives) && detail.objectives.length ? detail.objectives : [''],
        targets: Array.isArray(detail.targets) && detail.targets.length ? detail.targets : [''],
        completion_percent: detail.completion_percent ?? 0,
        exam_pass_percent: detail.exam_pass_percent ?? 0,
      })
    } else {
      setForm(EMPTY_FORM)
    }
    setSaveErr(null)
    setIsEditing(false)
  }

  if (loadingDetail) {
    return (
      <div className="flex items-center justify-center py-20 text-gray-400 gap-2">
        <Loader className="animate-spin w-5 h-5" /> กำลังโหลดข้อมูล…
      </div>
    )
  }

  return (
    <div className="space-y-12">
      {/* 1. คำอธิบายรายวิชา */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <BookOpen className="w-5 h-5 text-pink-500" />
          <h3 className="text-lg font-semibold">คำอธิบายรายวิชา</h3>
        </div>
        {isEditing ? (
          <textarea
            className="w-full border border-pink-200 rounded-xl p-4 focus:ring-2 focus:ring-pink-500 outline-none transition-all"
            rows={4}
            value={form.description}
            placeholder="กรอกคำอธิบายรายวิชา…"
            onChange={e => setField('description', e.target.value)}
          />
        ) : (
          <p className="text-gray-600 leading-relaxed pl-7 whitespace-pre-line">
            {form.description || <span className="italic text-gray-400">ยังไม่มีคำอธิบาย</span>}
          </p>
        )}
      </section>

      {/* 2. วัตถุประสงค์ */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Target className="w-5 h-5 text-pink-500" />
          <h3 className="text-lg font-semibold">วัตถุประสงค์</h3>
        </div>
        <div className="pl-7 space-y-3">
          {isEditing ? (
            <>
              {form.objectives.map((item, idx) => (
                <div key={idx} className="flex gap-2">
                  <input
                    className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-300 outline-none"
                    value={item}
                    placeholder={`วัตถุประสงค์ข้อที่ ${idx + 1}`}
                    onChange={e => setListItem('objectives', idx, e.target.value)}
                  />
                  {form.objectives.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeListItem('objectives', idx)}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                onClick={() => addListItem('objectives')}
                className="flex items-center gap-1 text-sm text-pink-500 hover:text-pink-600 mt-1 transition-colors"
              >
                <Plus className="w-4 h-4" /> เพิ่มวัตถุประสงค์
              </button>
            </>
          ) : (
            <ul className="space-y-3 text-gray-600">
              {form.objectives.filter(s => s.trim()).length === 0 ? (
                <li className="italic text-gray-400">ยังไม่มีวัตถุประสงค์</li>
              ) : (
                form.objectives.filter(s => s.trim()).map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">✔ {item}</li>
                ))
              )}
            </ul>
          )}
        </div>
      </section>

      {/* 3. เหมาะสำหรับ */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Users className="w-5 h-5 text-pink-500" />
          <h3 className="text-lg font-semibold">หลักสูตรนี้เหมาะสำหรับ</h3>
        </div>
        <div className="pl-7 space-y-3">
          {isEditing ? (
            <>
              {form.targets.map((item, idx) => (
                <div key={idx} className="flex gap-2">
                  <input
                    className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-300 outline-none"
                    value={item}
                    placeholder={`กลุ่มเป้าหมายที่ ${idx + 1}`}
                    onChange={e => setListItem('targets', idx, e.target.value)}
                  />
                  {form.targets.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeListItem('targets', idx)}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                onClick={() => addListItem('targets')}
                className="flex items-center gap-1 text-sm text-pink-500 hover:text-pink-600 mt-1 transition-colors"
              >
                <Plus className="w-4 h-4" /> เพิ่มกลุ่มเป้าหมาย
              </button>
            </>
          ) : (
            <ul className="space-y-3 text-gray-600">
              {form.targets.filter(s => s.trim()).length === 0 ? (
                <li className="italic text-gray-400">ยังไม่มีกลุ่มเป้าหมาย</li>
              ) : (
                form.targets.filter(s => s.trim()).map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 rounded-full bg-pink-400 shrink-0" /> {item}
                  </li>
                ))
              )}
            </ul>
          )}
        </div>
      </section>

      {/* 4. การรับวุฒิบัตร */}
      <section>
        <div className="flex items-center gap-2 mb-4">
          <GraduationCap className="w-5 h-5 text-pink-500" />
          <h3 className="text-lg font-semibold">การรับวุฒิบัตร</h3>
        </div>
        <div className="pl-7">
          {isEditing ? (
            <div className="flex flex-wrap items-center gap-6 bg-gray-50 p-4 rounded-xl">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">เรียนจบ</span>
                <input
                  type="number" min={0} max={100}
                  className="w-16 border border-gray-200 rounded px-2 py-1 text-center focus:ring-2 focus:ring-pink-300 outline-none"
                  value={form.completion_percent}
                  onChange={e => setField('completion_percent', e.target.value)}
                />
                <span className="text-sm text-gray-600">%</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">สอบผ่าน</span>
                <input
                  type="number" min={0} max={100}
                  className="w-16 border border-gray-200 rounded px-2 py-1 text-center focus:ring-2 focus:ring-pink-300 outline-none"
                  value={form.exam_pass_percent}
                  onChange={e => setField('exam_pass_percent', e.target.value)}
                />
                <span className="text-sm text-gray-600">%</span>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2 bg-gradient-to-r from-pink-50 to-white px-4 py-3 rounded-lg border border-pink-100">
              <div className="p-2 bg-white rounded-full shadow-sm">
                <CheckCircle className="w-5 h-5 text-green-500" />
              </div>
              <span className="text-gray-700">
                ผู้เรียนต้องเรียนจบ <strong>{form.completion_percent}%</strong> และสอบผ่าน <strong>{form.exam_pass_percent}%</strong> ขึ้นไป
              </span>
            </div>
          )}
        </div>
      </section>

      {/* Error */}
      {saveErr && (
        <p className="text-sm text-red-500 text-right">{saveErr}</p>
      )}

      {/* Action Buttons */}
      <div className="flex justify-end gap-3 pt-6 border-t">
        {isEditing && (
          <>
            <button
              onClick={handleCancel}
              disabled={saving}
              className="px-6 py-2.5 rounded-xl border border-gray-200 hover:bg-gray-50 text-gray-600 font-medium transition-colors flex items-center gap-2 disabled:opacity-50"
            >
              <X className="w-4 h-4" /> ยกเลิก
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-pink-500 to-rose-500 text-white font-medium shadow-lg shadow-pink-200 hover:shadow-pink-300 transform hover:-translate-y-0.5 transition-all flex items-center gap-2 disabled:opacity-60"
            >
              {saving ? <Loader className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              {saving ? 'กำลังบันทึก…' : 'บันทึก'}
            </button>
          </>
        )}
      </div>
    </div>
  )
}

/* ─── helper: resolve display metadata from sub-lesson type/url ─── */
function getSubLessonMeta(sub) {
  const type = (sub.type || '').toLowerCase()
  const url = sub.url || ''
  const ext = url.split('?')[0].split('.').pop().toLowerCase()

  if (['mp4', 'mov', 'avi', 'webm', 'mkv', 'flv', 'wmv'].includes(type) ||
    ['mp4', 'mov', 'avi', 'webm', 'mkv', 'flv', 'wmv'].includes(ext))
    return { kind: 'video', icon: '🎬', color: 'text-violet-600', label: 'วิดีโอ' }

  if (type === 'youtube' || url.includes('youtube.com') || url.includes('youtu.be'))
    return { kind: 'link', icon: '▶️', color: 'text-red-500', label: 'YouTube' }

  if (type === 'pdf' || ext === 'pdf')
    return { kind: 'file', icon: '📄', color: 'text-rose-500', label: 'PDF' }

  if (['doc', 'docx'].includes(type) || ['doc', 'docx'].includes(ext))
    return { kind: 'file', icon: '📝', color: 'text-blue-600', label: 'Word' }

  if (['xls', 'xlsx', 'csv'].includes(type) || ['xls', 'xlsx', 'csv'].includes(ext))
    return { kind: 'file', icon: '📊', color: 'text-green-600', label: 'Excel' }

  if (['ppt', 'pptx'].includes(type) || ['ppt', 'pptx'].includes(ext))
    return { kind: 'file', icon: '📑', color: 'text-orange-500', label: 'PowerPoint' }

  if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(type) ||
    ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(ext))
    return { kind: 'image', icon: '🖼️', color: 'text-pink-500', label: 'รูปภาพ' }

  if (['mp3', 'wav', 'ogg', 'aac', 'm4a'].includes(type) ||
    ['mp3', 'wav', 'ogg', 'aac', 'm4a'].includes(ext))
    return { kind: 'audio', icon: '🎵', color: 'text-teal-500', label: 'เสียง' }

  if (['link', 'url'].includes(type) || url.startsWith('http'))
    return { kind: 'link', icon: '🔗', color: 'text-green-600', label: 'ลิงก์' }

  if (['txt', 'md', 'text'].includes(type) || ['txt', 'md'].includes(ext))
    return { kind: 'file', icon: '📃', color: 'text-gray-500', label: 'ข้อความ' }

  if (['zip', 'rar', '7z', 'tar'].includes(type) || ['zip', 'rar', '7z', 'tar'].includes(ext))
    return { kind: 'file', icon: '🗜️', color: 'text-yellow-600', label: 'ไฟล์บีบอัด' }

  return { kind: 'file', icon: '📎', color: 'text-gray-500', label: type || 'ไฟล์' }
}

/* ─── sub-lesson row: renders the correct icon + clickable/preview title ─── */
function SubLessonRow({ sub, onRemove }) {
  const { kind, icon, color, label } = getSubLessonMeta(sub)

  const title = sub.title || sub.name || 'Untitled'
  const url = sub.url || ''
  const downloadUrl = sub.download_url || ''

  // file จริง = มี download_url
  const isFile = !!downloadUrl

  const handleOpen = () => {
    const target = downloadUrl || url
    if (!target) return
    window.open(target, '_blank', 'noopener')
  }

  const renderTitle = () => {
    // 🔗 link / youtube
    if (!isFile && url) {
      return (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="hover:underline underline-offset-2 text-sm"
        >
          {title}
        </a>
      )
    }

    // 📄 file ทุกชนิด (pdf / docx / mp4 / zip ...)
    return (
      <button
        onClick={handleOpen}
        className="hover:underline underline-offset-2 text-sm text-left"
      >
        {title}
      </button>
    )
  }

  return (
    <div className="flex justify-between items-start bg-gray-50 px-3 py-2 rounded-lg gap-2">
      <div className="flex items-start gap-2 min-w-0 flex-1">
        <span
          className={`mt-0.5 shrink-0 text-base leading-none ${color}`}
          title={label}
        >
          {icon}
        </span>

        <div className="flex flex-col min-w-0 flex-1">
          <span
            className={`text-[10px] font-semibold uppercase tracking-wide mb-0.5 ${color}`}
          >
            {label}
          </span>
          {renderTitle()}
        </div>
      </div>

      <button
        onClick={onRemove}
        className="text-red-400 hover:text-red-600 shrink-0 mt-0.5"
      >
        <Trash2 size={14} />
      </button>
    </div>
  )
}

function LessonTreeItem({ lesson, setDataLessons }) {
  const [open, setOpen] = useState(false)
  const { cid } = useParams()

  const removeSubLesson = (id) => {
    setDataLessons(prev =>
      prev.map(l =>
        l.lesson_id === lesson.lesson_id
          ? { ...l, sub_lessons: l.sub_lessons.filter(s => s.id !== id) }
          : l
      )
    )
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100">

      {/* Lesson Header */}
      <div
        onClick={() => setOpen(!open)}
        className="flex justify-between items-center px-4 py-3 cursor-pointer hover:bg-gray-50 rounded-2xl"
      >
        <div className="flex items-center gap-2">
          <BookOpen size={16} className="text-pink-500" />
          <span className="font-medium">{lesson.lesson_name}</span>
          <span className="text-sm text-gray-400">
            {lesson.sub_lessons?.length ?? 0} รายการ
          </span>
        </div>

        <Link
          to={`/content/${encodeURIComponent(cid)}/lessons/${encodeURIComponent(lesson.lesson_id)}/upload-content`}
          onClick={e => e.stopPropagation()}
          className="text-sm bg-pink-500 text-white px-4 py-1.5 rounded-lg hover:bg-pink-600 transition"
        >
          จัดการ
        </Link>
      </div>

      {/* Sub Lessons */}
      {open && (
        <div className="px-6 pb-4 space-y-2">
          {(lesson.sub_lessons || []).length === 0 ? (
            <p className="text-sm text-gray-400 py-2">ยังไม่มีเนื้อหา</p>
          ) : (
            (lesson.sub_lessons || []).map(sub => (
              <SubLessonRow
                key={sub.id}
                sub={sub}
                onRemove={() => removeSubLesson(sub.id)}
              />
            ))
          )}
        </div>
      )}
    </div>
  )
}

